import { v4 as uuidv4 } from 'uuid';
import dateUtil from '../../../../commons/utils/date';
import { getStore } from '../../factory';
import { getSubscriptionsAPI } from './api';

function buildCollections(activeSubs) {
    return activeSubs.slice(0, 4).map((sub) => ({
        id:   sub.id,
        name: sub.publisher?.name  || '',
        logo: sub.publisher?.logo  || '',
    }));
}

function buildSubscriptionMaps(allSubs) {
    const connectedSchedules = {};
    const subscriptionDetails = {};

    allSubs.forEach((sub) => {
        connectedSchedules[sub.id] = sub.subscribedSchedules || [];

        subscriptionDetails[sub.id] = {
            publisher:       sub.publisher || {},
            app:             sub.applications?.[0] || {},
            timezone:        sub.location?.timezone || '',
            lastSyncedLabel: dateUtil.timeAgo(sub.lastSynced),
            isActive:        sub.isActive,
        };
    });

    return { connectedSchedules, subscriptionDetails };
}

async function getSubscriptions() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.startSubscriptionProgress();

    const res = await getSubscriptionsAPI({
        store: this,
        token: session.token,
        traceId,
        page: this.page,
    });

    this.stopSubscriptionProgress();

    if (res.error) return;

    if (res?.data?.data?.results) {
        const { active, inactive, devices } = this.selectActiveInactive(res.data.data.results);

        this.subscriptions = [...this.subscriptions, ...active];
        this.inactiveSubscriptions = [...this.inactiveSubscriptions, ...inactive];

        const { connectedSchedules, subscriptionDetails } = buildSubscriptionMaps([
            ...this.subscriptions,
            ...this.inactiveSubscriptions,
        ]);

        this.connectedSchedules = connectedSchedules;
        this.subscriptionDetails = subscriptionDetails;

        const loaded = this?.pageInfo?.totalLoaded || 0;
        this.pageInfo = {
            currentPage: res.data.data.currentPage,
            totalPages: res.data.data.totalPages,
            totalRecords: res.data.data.totalRecords,
            totalLoaded: parseInt(loaded) + res.data.data.results.length,
        };

        // Push flattened collections (first 4 active) to profileStore
        const profileStore = getStore('profile');
        if (profileStore) {
            profileStore.collections = buildCollections(this.subscriptions);
            profileStore.observed.collections = uuidv4();
        }

        this.observed.subscriptions = uuidv4();
        this.env.profileStore.updateDevices(devices);
    }
}

export default getSubscriptions;
